import { Icon, ICONS, mixins } from '@bob/library'
import { useStaticText } from '@websrc/App/Hooks/useStaticText'
import { SpotDistributorCardProps } from '@websrc/Spot/Distributor/Card/SpotDistributorCard'
import React, { useState } from 'react'

import * as SC from './SpotDistributorCardMainMarket.style'

export interface SpotDistributorCardMainMarketProps {
  distributor: SpotDistributorCardProps['distributor']
}

export const SpotDistributorCardMainMarket = ({
  distributor,
}: SpotDistributorCardMainMarketProps) => {
  const t = useStaticText()
  const [expand, setExpand] = useState(false)
  const cutTextLength = 70

  const deliverLabel = t.shop.deliver_to
  const deliverText = distributor.deliversTo || ''

  const productLabel = t.shop.products
  const productText = distributor.products || ''

  const seeMore = <SC.SeeMore onClick={() => setExpand(true)}>{t.ecom.show_more}</SC.SeeMore>

  const mainMarketInfo = (label: string, text: string) => (
    <SC.MainMarketInfo>
      {!expand && label.concat(text).length > cutTextLength ? (
        <>
          <b>{label}:</b> {text.slice(0, cutTextLength)}... {seeMore}
        </>
      ) : (
        <>
          <b>{label}:</b> {text}
        </>
      )}
    </SC.MainMarketInfo>
  )

  return (
    <>
      {expand && (
        <SC.CloseButton data-testid={'close-button'} onClick={() => setExpand(false)}>
          <Icon color={mixins.colors.corporateBlue} icon={ICONS.CROSS} size={20} />
        </SC.CloseButton>
      )}
      {distributor.deliversTo && mainMarketInfo(deliverLabel, deliverText)}
      {distributor.products && mainMarketInfo(productLabel, productText)}
    </>
  )
}
